import { render } from "./MnSettings.vue?vue&type=template&id=4f90c2da"
import script from "./MnSettings.vue?vue&type=script&lang=js"
export * from "./MnSettings.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__